import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Notificacoes() {
  const [notificacoes] = useState([
    {
      id: 1,
      titulo: 'Fatura Paga',
      mensagem: 'Sua fatura de janeiro foi paga com sucesso.',
      tipo: 'success',
      data: '2025-02-13T10:30:00',
      lida: true
    },
    {
      id: 2,
      titulo: 'Manutenção Programada',
      mensagem: 'Manutenção agendada para 20/02/2025 às 02:00h. Pode haver interrupção breve do serviço.',
      tipo: 'info',
      data: '2025-02-10T14:15:00',
      lida: false
    },
    {
      id: 3,
      titulo: 'Promoção Especial',
      mensagem: 'Aproveite nossa promoção de férias! Upgrade para o plano HARDCORE GAMER com 20% de desconto.',
      tipo: 'promo',
      data: '2025-02-08T09:45:00',
      lida: false
    },
    {
      id: 4,
      titulo: 'Chamado Resolvido',
      mensagem: 'Seu chamado #12345 foi resolvido. Avalie nosso atendimento.',
      tipo: 'success',
      data: '2025-02-05T16:20:00',
      lida: true
    }
  ]);

  const [configuracoes, setConfiguracoes] = useState({
    email: true,
    push: true,
    sms: false,
    faturas: true,
    manutencao: true,
    promocoes: false
  });

  const handleConfigChange = (key) => {
    setConfiguracoes(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const getTipoIcon = (tipo) => {
    switch (tipo) {
      case 'success':
        return 'fas fa-check-circle';
      case 'info':
        return 'fas fa-info-circle';
      case 'warning':
        return 'fas fa-exclamation-triangle';
      case 'promo':
        return 'fas fa-gift';
      default:
        return 'fas fa-bell';
    }
  };

  const getTipoClass = (tipo) => {
    switch (tipo) {
      case 'success':
        return 'success';
      case 'info':
        return 'info';
      case 'warning':
        return 'warning';
      case 'promo':
        return 'promo';
      default:
        return 'default';
    }
  };

  const formatarData = (dataString) => {
    const data = new Date(dataString);
    const agora = new Date();
    const diffMs = agora - data;
    const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffDias === 0) {
      return 'Hoje';
    } else if (diffDias === 1) {
      return 'Ontem';
    } else if (diffDias < 7) {
      return `Há ${diffDias} dias`;
    } else {
      return data.toLocaleDateString('pt-BR');
    }
  };

  return (
    <div className="notificacoes-page">
      <div className="container">
        <div className="page-header">
          <h1>Notificações</h1>
          <p>Mantenha-se informado sobre sua conta</p>
        </div>

        <div className="notificacoes-grid">
          {/* Lista de Notificações */}
          <div className="notificacoes-lista">
            <div className="lista-header">
              <h3>Histórico de Notificações</h3>
              <div className="filtros">
                <button className="filtro-btn active">Todas</button>
                <button className="filtro-btn">Não lidas</button>
                <button className="filtro-btn">Importantes</button>
              </div>
            </div>

            <div className="notificacoes-container">
              {notificacoes.map((notif) => (
                <div key={notif.id} className={`notificacao-item ${notif.lida ? 'lida' : 'nao-lida'} ${getTipoClass(notif.tipo)}`}>
                  <div className="notificacao-icon">
                    <i className={getTipoIcon(notif.tipo)}></i>
                  </div>
                  <div className="notificacao-content">
                    <div className="notificacao-header">
                      <h4>{notif.titulo}</h4>
                      <span className="notificacao-data">{formatarData(notif.data)}</span>
                    </div>
                    <p>{notif.mensagem}</p>
                    {!notif.lida && <span className="badge-nova">Nova</span>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Configurações */}
          <div className="configuracoes-card">
            <h3>Configurações de Notificações</h3>
            
            <div className="config-section">
              <h4>Canais de Notificação</h4>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.email}
                    onChange={() => handleConfigChange('email')}
                  />
                  <span>E-mail</span>
                </label>
              </div>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.push}
                    onChange={() => handleConfigChange('push')}
                  />
                  <span>Notificações Push</span>
                </label>
              </div>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.sms}
                    onChange={() => handleConfigChange('sms')}
                  />
                  <span>SMS</span>
                </label>
              </div>
            </div>

            <div className="config-section">
              <h4>Tipos de Notificação</h4>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.faturas}
                    onChange={() => handleConfigChange('faturas')}
                  />
                  <span>Faturas e Pagamentos</span>
                </label>
              </div>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.manutencao}
                    onChange={() => handleConfigChange('manutencao')}
                  />
                  <span>Manutenções e Interrupções</span>
                </label>
              </div>
              <div className="config-item">
                <label>
                  <input
                    type="checkbox"
                    checked={configuracoes.promocoes}
                    onChange={() => handleConfigChange('promocoes')}
                  />
                  <span>Promoções e Ofertas</span>
                </label>
              </div>
            </div>

            <button className="btn-primary">Salvar Configurações</button>
          </div>
        </div>

        <div className="acoes-adicionais">
          <Link to="/central" className="btn-secondary">
            <i className="fas fa-arrow-left"></i>
            Voltar ao Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Notificacoes; 